import React from 'react';
import { get } from 'lodash';
import { Icon } from '../../../../../../../components/common';

export const getIconTypeClient = (data, iconSize = 20, fontSize = 20) => (
    <div style={{ display: 'inline' }}>
        {get(data, 'customer.isUltraVIP') && <Icon name='ultravip' size={iconSize} right={5} color='#1C8AF5' />}
        {get(data, 'customer.isVIP') && <Icon name='vip' size={iconSize} right={5} color='#4DB457' />}
        {get(data, 'customer.isCencoPrime') && <span style={{ fontSize }}>
            <span className='icon-ic-prime'>
                <span className='path1' />
                <span className='path2' />
            </span>
        </span>}
    </div>
);
